require('./cardChangePaymentMethodView.scss');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @actions
const cardChangePaymentMethodActions = require('actions/cardChangePaymentMethod');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const CardChangePaymentMethod = require('components/cards/cardChangePaymentMethod/cardChangePaymentMethod');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardChangePaymentMethodSuccessStep = require('components/cards/cardChangePaymentMethodSteps/cardChangePaymentMethodSuccessStep/cardChangePaymentMethodSuccessStep');
const CardChangePaymentMethodErrorStep = require('components/cards/cardChangePaymentMethodSteps/cardChangePaymentMethodErrorStep/cardChangePaymentMethodErrorStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const WebappRender = require('components/conditionalRender/webappRender')

// @utilites
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname')

// @constants
const { CARD_INTERVENTION_OWNER } = require('constants/index');
const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

class CardChangePaymentMethodView extends React.Component {
    constructor(props) {
        super(props);

        this.handleFinish = this.handleFinish.bind(this);
        this.goToMovementsPage = this.goToMovementsPage.bind(this);
    }

    componentDidMount() {
        const { history, match: { params: { cardId } }, immCards, immFlagBasedFeatures } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_CHANGE_PAYMENT_METHOD, { immCard, immFlagBasedFeatures }, history);
        this.props.requestPaymentMethodInfo(cardId);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/cambio-metodo-pago', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    goToMovementsPage() {
        const { history, match: { params: { cardId } } } = this.props;

        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    handleFinish() {
        const { match: { params: { cardId } } } = this.props;
        this.props.postChange(cardId);
    }

    render() {
        const {
            match: { params: { cardId } },
            handleAgreementCheckboxChange,
            immCards,
            immCardChangePaymentMethod,
            validateStep,
            setVisibleStep,
            setWillCancel,
            postChange,
            immGlobalVariables,
            immFlagBasedFeatures,
        } = this.props;

        const immCard = immCards.get('byId').get(cardId);
        let content = (<div></div>);

        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            if (immCard.get('interventionType') !== CARD_INTERVENTION_OWNER) {
                this.goToMovementsPage();
            }
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const hasError = !!immCardChangePaymentMethod.get('error');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardChangePaymentMethod-title')
                }
            ];
            let bodyContent;

            if (immCardChangePaymentMethod.get('submitSuccessful')) {
                bodyContent = (
                    <CardChangePaymentMethodSuccessStep
                        immCard={immCard}
                        immCardChangePaymentMethod={immCardChangePaymentMethod}
                    />
                );
            } else if (hasError) {
                bodyContent = (
                    <CardChangePaymentMethodErrorStep
                        immCard={immCard}
                        immCardChangePaymentMethod={immCardChangePaymentMethod}
                    />
                );
            } else {
                const changePaymentSidebarClassName = conditionalClassName('hidden-md', 'col-md-4', 'hidden-xs hidden-sm col-lg-4')
                const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
                bodyContent = (
                    <div>
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <WebappRender>
                            <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                <CardDetailsSidebar immCard={immCard} />
                            </div>
                        </WebappRender>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className="col-md-12-cc-8 col-lg-8">
                            <CardChangePaymentMethod
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                immCard={immCard}
                                immCardChangePaymentMethod={immCardChangePaymentMethod}
                                immGlobalVariables={immGlobalVariables}
                                validateStep={validateStep}
                                setVisibleStep={setVisibleStep}
                                setWillCancel={setWillCancel}
                                showIneAndRevolving={showIneAndRevolving}
                                postChange={postChange}
                                onFinish={this.handleFinish}
                                isDisabledButton={immCardChangePaymentMethod.get('isDisabledButton')}
                            />
                        </div>
                        {/* >> REF-01 */}
                        <div className={changePaymentSidebarClassName}>
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            const changePaymentBodyClassName = contactCenterClassName('card-change-payment-method-view__body', 'grid-view__body')
            const changePaymentContainerClassName = contactCenterClassName('card-change-payment-method-view__container', 'container-fluid')
            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={getFinalTitle('cardChangePaymentMethod-title')}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={changePaymentBodyClassName}>
                        <div className={changePaymentContainerClassName}>
                            <div className="row grid-view--content-position-negative">
                                {bodyContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return content;
    }
}

CardChangePaymentMethodView.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardChangePaymentMethod: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    postChange: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    requestPaymentMethodInfo: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.constructor = CardChangePaymentMethodView;
module.exports.CardChangePaymentMethodView = connect(
    state => ({
        immCards: state.cards,
        immCardChangePaymentMethod: state.cardChangePaymentMethod,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
    }), {
    handleAgreementCheckboxChange: cardChangePaymentMethodActions.setAgreementCheckbox,
    validateStep: cardChangePaymentMethodActions.validateStep,
    setVisibleStep: cardChangePaymentMethodActions.setVisibleStep,
    setWillCancel: cardChangePaymentMethodActions.setWillCancel,
    postChange: cardChangePaymentMethodActions.postChange,
    clearRequest: cardChangePaymentMethodActions.clearRequest,
    requestPaymentMethodInfo: cardChangePaymentMethodActions.requestPaymentMethodInfo
})(withRouter(CardChangePaymentMethodView));
